export interface ColorMarkedSegment {
  text: string;
  color?: string;
  bold?: boolean;
}

// Znaczniki stylu w tekstach wpisywanych w BO (moduł contelizercarrierhours):
// kolor „Kup do 14:00 - [#16a34a]dostawa jutro[/]”, pogrubienie „[b]tylko
// dziś[/]”, łączone w jednym znaczniku „[#16a34a b]dostawa jutro[/]”
// (znaczniki się nie zagnieżdżają). Hex 3- lub 6-znakowy, zamknięcie [/]
// albo z powtórzonymi tokenami ([/b], [/#hex]). Backend przepuszcza nawiasy
// kwadratowe bez zmian (pSQL wycina tylko tagi HTML), więc parsowanie
// odbywa się wyłącznie tutaj.
const STYLE_TOKEN = "(?:b|#(?:[0-9a-fA-F]{6}|[0-9a-fA-F]{3}))";
const COLOR_MARKER_RE = new RegExp(
  `\\[(${STYLE_TOKEN}(?:\\s+${STYLE_TOKEN})*)\\](.*?)\\[/(?:${STYLE_TOKEN}(?:\\s+${STYLE_TOKEN})*)?\\]`,
  "g",
);

// Niepoprawny lub niedomknięty znacznik zostaje w tekście literalnie —
// admin od razu widzi w sklepie, że składnia jest zła.
export function parseColorMarkedText(text: string): ColorMarkedSegment[] {
  if (!text) {
    return [];
  }

  const segments: ColorMarkedSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(COLOR_MARKER_RE)) {
    const index = match.index ?? 0;
    if (index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, index) });
    }
    if (match[2]) {
      const segment: ColorMarkedSegment = { text: match[2] };
      for (const token of match[1].split(/\s+/)) {
        if (token === "b") {
          segment.bold = true;
        } else {
          segment.color = token;
        }
      }
      segments.push(segment);
    }
    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex) });
  }

  return segments;
}
